import React from 'react'
import OtpComp from '../../components/auth/OtpComp'

const Otp = () => {
  return (
    <div>
        <OtpComp />
    </div>
  )
}

export default Otp